product<template>
  <div class="ctrl-login">
    <div class="wrap1100">
      <CtrlProduct />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlProduct from "@/components/Ctrl/Product.vue";
export default {
  name: "ctrl-login",
  components: {
    CtrlProduct,
  },
  props: {
    categoryId: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
